import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { UpdateApplicationRoute } from 'src/redux/actions/Application';
import { Store } from 'src/types';

const NON_EMPTY_REGEX = /^(?!\s*$).+/;
const EMAIL_REGEX = /^\w+([\.\-\+]\w+)*@\w+([.-]\w+)*\.\w{2,3}$/;
const NUMBER_REGEX = /^[0-9]/;

const displayErrorToast = (text: string) =>
  toast(text, {
    type: 'error',
  });

const pagesFlow = [
  '/start-application',
  '/quote-information',
  '/coverages-details',
  '/payment',
  '/confirmation',
];

const fieldsRegexToCheckPerPage = new Map();
fieldsRegexToCheckPerPage.set(pagesFlow[0], {
  firstName: NON_EMPTY_REGEX,
  lastName: NON_EMPTY_REGEX,
  email: EMAIL_REGEX,
  phone: NUMBER_REGEX,
  addressName: NON_EMPTY_REGEX,
  'address.street': NON_EMPTY_REGEX,
  'address.municipality': NON_EMPTY_REGEX,
  'address.postalCode': NUMBER_REGEX,
  'address.state': NON_EMPTY_REGEX,
});
fieldsRegexToCheckPerPage.set(pagesFlow[1], {
  coverageStart: NON_EMPTY_REGEX,
  additionalInterests: NON_EMPTY_REGEX,
  additionalInsuredRoommates: NON_EMPTY_REGEX,
});

const checkFieldAgainstRegex = (currentValue: any, regex: RegExp) => {
  return regex.test(currentValue);
};

const checkAdditionalPersonOrEntityAgainstRegex = (currentValue: {[key: string]: string}[]) => {
    if(currentValue.length==0){return true}
    for(const additionalPersonOrEntity of currentValue){
      if (
        checkFieldAgainstRegex(additionalPersonOrEntity.firstName, NON_EMPTY_REGEX) &&
        checkFieldAgainstRegex(additionalPersonOrEntity.lastName, NON_EMPTY_REGEX) &&
        checkFieldAgainstRegex(additionalPersonOrEntity.email, EMAIL_REGEX)
      ) {
        return true;
      } else {
        return false;
      }
    }
}

const checkIfValueIsValid = (
  fieldName: any,
  currentValue: any,
  regex: RegExp,
) => {

  if (fieldName == 'additionalInterests' || fieldName == 'additionalInsuredRoommates') {
    return checkAdditionalPersonOrEntityAgainstRegex(currentValue) ? true : false
  }

  if (!checkFieldAgainstRegex(currentValue, regex)) {
    return false;
  }

  return true;
};

const useGoToPreviousPageIfDataMissing = (currentUrl: string) => {

  const application = useSelector((state: Store) => state.application);
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    const previousUrlIndex = pagesFlow.indexOf(currentUrl) - 1;
    const goToPreviousPageAndDisplayError= () => {
      dispatch(UpdateApplicationRoute(previousPageUrl));
      history.push(previousPageUrl);
      displayErrorToast('A Field is empty or has been modified and is not valid anymore')
    }

    const previousPageUrl = previousUrlIndex<0 ? '' : pagesFlow[previousUrlIndex];
    if(previousPageUrl=='' || !fieldsRegexToCheckPerPage.get(previousPageUrl)) { return }

    for (const [field, regex] of Object.entries(
      fieldsRegexToCheckPerPage.get(previousPageUrl),
    )) {

      const storeValue: any =
        field.split('.').reduce((a: any, b: any) => a[b], application.data) ||
        '';
      if (
        !checkIfValueIsValid(
          field,
          storeValue,
          regex as RegExp,
        )
      ) {
        goToPreviousPageAndDisplayError()
      }

    }
  }, [history, dispatch, application, currentUrl]);
};

export default useGoToPreviousPageIfDataMissing;
